//To load the chatbot if enabled for an organization

export const loadChatBot = ({
  chatBotApiUrl,
  benApiUrl,
  identity,
}: {
  chatBotApiUrl: string;
  benApiUrl: string;
  identity: any;
}) => {
  const chatbotApi = document.getElementById('chatbot_api_url');
  if (!chatbotApi) {
    const input = document.createElement('input');
    input.setAttribute('value', chatBotApiUrl);
    input.setAttribute('id', 'chatbot_api_url');
    input.setAttribute('type', 'hidden');
    document.body.appendChild(input);

    const apiInput = document.createElement('input');
    apiInput.setAttribute('value', benApiUrl);
    apiInput.setAttribute('id', 'benadmin_api_url');
    apiInput.setAttribute('type', 'hidden');
    document.body.appendChild(apiInput);

    const userIdentity = document.createElement('input');
    userIdentity.setAttribute('value', identity);
    userIdentity.setAttribute('id', 'chatbot_identity');
    userIdentity.setAttribute('type', 'hidden');
    document.body.appendChild(userIdentity);

    const userSessionID = document.createElement('input');
    userSessionID.setAttribute('id', 'user_session_id');
    userSessionID.setAttribute('type', 'hidden');
    document.body.appendChild(userSessionID);

    const organizationID = document.createElement('input');
    organizationID.setAttribute('id', 'org_id');
    organizationID.setAttribute('type', 'hidden');
    document.body.appendChild(organizationID);
  }
};

export const chatBotEntity = ({ subscriberId }: { subscriberId: any }) => {
  const chatBotEl = document.getElementById('chatbot_identity');
  chatBotEl && chatBotEl.setAttribute('value', subscriberId);
};

export const chatBotSessionId = ({ sessionId }: { sessionId: any }) => {
  const userSessionEl = document.getElementById('user_session_id');
  userSessionEl && userSessionEl.setAttribute('value', sessionId);
};

export const chatBotOrgId = ({ orgId }: { orgId: any }) => {
  const organizationEl = document.getElementById('org_id');
  organizationEl && organizationEl.setAttribute('value', orgId);
};

export const setChatBotState = (styleData: string, visibility: string) => {
    document
      .querySelector('.chat-bot')
      ?.setAttribute('style', styleData);
    const chatBotState = document.querySelector('.chat-bot-state');
    if (chatBotState) {
      chatBotState.setAttribute('value', visibility);
    } else {
      const chatBotElement = document.createElement('div');
      chatBotElement.setAttribute('class', 'chat-bot-state');
      chatBotElement.setAttribute('type', 'hidden');
      const bodyElement = document.querySelector('body');
      bodyElement?.append(chatBotElement);
    }
};
